import PropTypes from 'prop-types';

import { IconWarningOutline } from '@zillow/constellation-icons';
import { Box, Button, Icon, Paragraph } from '@zillow/constellation-10';

import { PAYMENT_CONSTANTS } from '../../../constants/PaymentConstants';

const propTypes = {
  errorMessage: PropTypes.string.isRequired,
  defaultErrorMessage: PropTypes.string,
  isInMaintenanceMode: PropTypes.bool,
};

const defaultProps = {
  defaultErrorMessage: PAYMENT_CONSTANTS.ERROR_TYPE.DEFAULT,
  isInMaintenanceMode: false,
};

const PaymentError = ({ errorMessage, defaultErrorMessage, isInMaintenanceMode }) => (
  <Box css={{ textAlign: 'center' }}>
    <Box
      css={{
        paddingInline: '600',
        paddingBlock: '800',
        backgroundColor: isInMaintenanceMode ? 'bg.accent.yellow.impact' : 'bg.express.empower.hero',
        margin: '0px {spacing.-400}',
      }}
      data-testid={`PaymentError-header ${isInMaintenanceMode ? 'maintenanceMode' : ''}`}
    >
      <Icon css={{ color: 'icon.onHero.neutral' }} size="xl" render={<IconWarningOutline />} />
    </Box>
    <Paragraph css={{ padding: '800' }} className="PaymentError-body">
      {errorMessage || defaultErrorMessage}
    </Paragraph>
    <Button fluid tone="brand" emphasis="outlined" css={{ paddingBottom: '400' }} onClick={() => location.reload()}>
      Reload page
    </Button>
  </Box>
);

PaymentError.propTypes = propTypes;
PaymentError.defaultProps = defaultProps;

export default PaymentError;
